 <template>
  <div>
    <el-dialog
      title="รายละเอียดรายการส่งเสริมการขาย"
      :visible.sync="show"
      :label-position="labelPosition"
      :before-close="handleClose"
    >
      <el-form>
        <table>
          <tr>
            <td colspan="2">รายละเอียดเบื้องต้น</td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ชื่อรายการส่งเสริมการขาย :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_name_th}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ประเภทบริการของรายการส่งเสริมการขาย :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_category == 'postpaid' ? 'รายเดือน' : 'เติมเงิน'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ชนิดของรายการส่งเสริมการขาย :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_type === 'main' ? 'รายการส่งเสริมการขายหลัก':'รายการส่งเสริมการขายเสริม'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ระยะเวลา :
            </td>
            <td v-bind:style="styleOption">
              {{moment(info.start_service_date).add(543, 'y').format('DD-MM-YYYY')}} ถึง{{moment(info.end_service_date).add(543, 'y').format('DD-MM-YYYY') != moment(new Date()).add(543, 'y').format('DD-MM-YYYY') ? ' ' + moment(info.end_service_date).add(543, 'y').format('DD-MM-YYYY') : 'ปัจจุบัน'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_price}} บาท
            </td>
          </tr>
          <tr>
            <td colspan="2">สิทธิการใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ</td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              บริการเสียง :
            </td>
            <td v-bind:style="styleOption">
              {{info.voice_minute ? info.voice_minute + ' นาที' : info.voice_second ? info.voice_second + ' วินาที' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              บริการ SMS :
            </td>
            <td v-bind:style="styleOption">
              {{info.sms_amount ? info.sms_amount + ' ข้อความ' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              บริการ MMS :
            </td>
            <td v-bind:style="styleOption">
              {{info.mms_amount ? info.mms_amount + ' ข้อความ' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              บริการอินเทอร์เน็ต :
            </td>
            <td v-bind:style="styleOption">
              {{info.internet_MB ? info.internet_MB + ' MB' : info.internet_GB ? info.internet_GB + ' GB' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ความเร็วอินเทอร์เน็ต :
            </td>
            <td v-bind:style="styleOption">
              {{info.internet_speed_Kbps ? info.internet_speed_Kbps + ' Kbps' : info.internet_speed_Mbps ? info.internet_speed_Mbps + ' Mbps' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              Wifi :
            </td>
            <td v-bind:style="styleOption">
              {{info.wifi_service_th ? info.wifi_service_th : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              อื่นๆ :
            </td>
            <td v-bind:style="styleOption">
              {{info.other_service_th ? info.other_service_th : '-'}}
            </td>
          </tr>
          <tr>
            <td colspan="2">อัตราค่าบริการเฉลี่ย</td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ค่าบริการเสียง :
            </td>
            <td v-bind:style="styleOption">
              {{info.voice_per_minute ? Math.round(info.voice_per_minute * 100)/100 + ' บาท/นาที' : info.voice_per_second ? info.voice_per_second + ' บาท/วินาที' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ค่าบริการ SMS :
            </td>
            <td v-bind:style="styleOption">
              {{info.sms_per_message ? info.sms_per_message + ' บาท/ข้อความ' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ค่าบริการ MMS :
            </td>
            <td v-bind:style="styleOption">
              {{info.mms_per_message ? info.mms_per_message + ' บาท/ข้อความ' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ค่าบริการอินเทอร์เน็ต :
            </td>
            <td v-bind:style="styleOption">
              {{info.internet_per_MB ? info.internet_per_MB + ' บาท/MB' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              Wifi :
            </td>
            <td v-bind:style="styleOption">
              {{info.masr_wifi_service ? info.masr_wifi_service : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              อื่นๆ :
            </td>
            <td v-bind:style="styleOption">
              {{info.masr_other_service ? info.masr_other_service : '-'}}
            </td>
          </tr>

          <tr></tr>
          <tr>
            <td v-bind:style="styleOption">
              รูปแบบการคิดค่าบริการประเภทเสียง :
            </td>
            <td v-bind:style="styleOption">
              {{info.service_charge_type == 'minute' ? 'นาที' : info.service_charge_type == 'วินาที' ? 'วินาที' : '-' }}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              เงื่อนไขอื่นๆ / ข้อกำหนด ของการใช้บริการ :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_condition_th ? info.promotion_condition_th : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              สิทธิพิเศษ :
            </td>
            <td v-bind:style="styleOption">
              -
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ลิงก์เว็บไซต์ หรือ ลิงก์รายการส่งเสริมการขาย :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_link_url ? info.promotion_link_url : '-'}}
            </td>
          </tr>
        </table>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      labelPosition: "top",
      show: false,
      month: [],
      styleOption: {
        textAlign: 'left',
        // border: '1px solid black',
        width: '55%'
      },
      styleCaption: {
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 'bold'
      }
    };
  },
  watch: {
    dialog() {
      this.show = this.dialog;
    }
  },
  props: ["info", "dialog"],
  methods: {
    handleClose(done) {
      this.$emit("checkModal", false);
      done();
    }
  }
};
</script>
 